// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActivitySummaryRecordDto } from './IClaimActivitySummaryRecordDto';
import {
    IClaimActivitySummaryRecordDtoFromJSON,
    IClaimActivitySummaryRecordDtoFromJSONTyped,
    IClaimActivitySummaryRecordDtoToJSON,
    IClaimActivitySummaryRecordDtoToJSONTyped,
} from './IClaimActivitySummaryRecordDto';
import type { IReportSummaryGroupDtoClaimActivitySummaryRecordDto } from './IReportSummaryGroupDtoClaimActivitySummaryRecordDto';
import {
    IReportSummaryGroupDtoClaimActivitySummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoClaimActivitySummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoClaimActivitySummaryRecordDtoToJSON,
    IReportSummaryGroupDtoClaimActivitySummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoClaimActivitySummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoClaimActivitySummaryRecordDto
 */
export interface IReportSummaryDtoClaimActivitySummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoClaimActivitySummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IClaimActivitySummaryRecordDto>}
     * @memberof IReportSummaryDtoClaimActivitySummaryRecordDto
     */
    employer_records?: Array<IClaimActivitySummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoClaimActivitySummaryRecordDto>}
     * @memberof IReportSummaryDtoClaimActivitySummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoClaimActivitySummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoClaimActivitySummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoClaimActivitySummaryRecordDto(value: object): value is IReportSummaryDtoClaimActivitySummaryRecordDto {
    return true;
}

export function IReportSummaryDtoClaimActivitySummaryRecordDtoFromJSON(json: any): IReportSummaryDtoClaimActivitySummaryRecordDto {
    return IReportSummaryDtoClaimActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoClaimActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoClaimActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IClaimActivitySummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoClaimActivitySummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoClaimActivitySummaryRecordDtoToJSON(json: any): IReportSummaryDtoClaimActivitySummaryRecordDto {
    return IReportSummaryDtoClaimActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoClaimActivitySummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoClaimActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IClaimActivitySummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoClaimActivitySummaryRecordDtoToJSON)),
    };
}

